import { styled, Theme, MainColor } from '@nexelem/deprecated-theme';
import { IconComponentProps } from '@nexelem/icons';
import { FC, useMemo } from 'react';

export const useFontAwesomeColorIcon = (Icon: FC<IconComponentProps>, color: MainColor) =>
  useMemo<FC<IconComponentProps>>(() => getColorIcon(Icon, color), [Icon, color]);

export const getColorIcon = (Icon: FC<IconComponentProps>, color: MainColor) => {
  const InternalComponent = styled(Icon)(({ theme }) => {
    const {
      palette: { getColor },
    } = theme as Theme;
    return {
      '&&': {
        color: getColor(color),
      },
    };
  });
  InternalComponent.displayName = `${color}(Color${Icon.displayName})`;
  return InternalComponent;
};
